const postInterviewNotice = `Congratulations! You just finished your interview with MIR. Please stay on this page and give us a moment to generate the feedback for you.\n`

const unAuthorizedNotice = `Please sign in to see the feedback.`

const badIdNotice = `Please return to the home page.`

export {postInterviewNotice, unAuthorizedNotice, badIdNotice};